export const PROJECT_STATS = {
  mealsDelivered: { value: 100, suffix: "k+" },
  brandCollaborations: { value: 25, suffix: "+" },
  averageRating: { value: 4.5, suffix: "/5", decimal: true },
};